import React from 'react';
import { useApp } from '../context/AppContext';
import { getColors, fonts } from '../theme';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

const TermsPage = () => {
  const { isDark } = useApp();
  const colors = getColors(isDark);
  const navigate = useNavigate();

  const sections = [
    {
      title: '1. Acceptance of Terms',
      content: `By accessing and using mind. ("the Service"), operated by Mill Creek Media LLC, a Colorado limited liability company based in Fort Collins, CO, you agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use the Service.`
    },
    {
      title: '2. Description of Service',
      content: `mind. is a personal habit tracking and goal management application operated by Mill Creek Media LLC. The Service allows users to track daily habits, manage tasks, set goals, and monitor personal progress. The Service is provided "as is" and we reserve the right to modify, suspend, or discontinue any aspect of the Service at any time.`
    },
    {
      title: '3. User Accounts',
      content: `To use the Service, you must create an account using a valid email address or third-party authentication provider. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.`
    },
    {
      title: '4. User Data and Privacy',
      content: `We collect and store personal data necessary to provide the Service, including your email address, authentication information, and any data you input into the application (habits, tasks, goals, etc.). Your data is encrypted and stored securely. We do not sell, share, or distribute your personal data to third parties except as required by law or to provide the Service. You retain ownership of all content you create within the Service.`
    },
    {
      title: '5. Acceptable Use',
      content: `You agree to use the Service only for lawful purposes and in accordance with these Terms. You agree not to: (a) use the Service in any way that violates applicable laws or regulations; (b) attempt to gain unauthorized access to any part of the Service; (c) interfere with or disrupt the integrity or performance of the Service; (d) use automated systems or software to extract data from the Service.`
    },
    {
      title: '6. Intellectual Property',
      content: `The Service, including its original content, features, and functionality, is owned by Mill Creek Media LLC and is protected by international copyright, trademark, and other intellectual property laws. You may not copy, modify, distribute, or create derivative works based on the Service without our express written permission.`
    },
    {
      title: '7. Disclaimer of Warranties',
      content: `THE SERVICE IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. WE DO NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED, SECURE, OR ERROR-FREE. YOUR USE OF THE SERVICE IS AT YOUR SOLE RISK.`
    },
    {
      title: '8. Limitation of Liability',
      content: `IN NO EVENT SHALL MILL CREEK MEDIA LLC BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR RELATED TO YOUR USE OF THE SERVICE. OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT YOU PAID FOR THE SERVICE IN THE TWELVE MONTHS PRECEDING THE CLAIM.`
    },
    {
      title: '9. Account Termination',
      content: `We reserve the right to suspend or terminate your account at any time for any reason, including violation of these Terms. Upon termination, your right to use the Service will immediately cease. You may delete your account at any time through the application settings.`
    },
    {
      title: '10. Changes to Terms',
      content: `We reserve the right to modify these Terms at any time. We will notify users of any material changes by posting the updated Terms on the Service. Your continued use of the Service after such changes constitutes acceptance of the new Terms.`
    },
    {
      title: '11. Governing Law',
      content: `These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which the Service operates, without regard to its conflict of law provisions.`
    },
    {
      title: '12. Contact Information',
      content: `If you have any questions about these Terms, please contact us through the application or at our official support channels.`
    }
  ];

  return (
    <div 
      className="min-h-screen py-12 px-6"
      style={{ backgroundColor: colors.bg }}
    >
      <div className="max-w-3xl mx-auto">
        {/* Back Button */}
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 mb-8 text-sm transition-all duration-200 hover:opacity-70"
          style={{ color: colors.accent }}
        >
          <ArrowLeft size={16} />
          Back
        </button>

        {/* Header */}
        <div className="mb-12">
          <h1 
            className="text-4xl mb-4 font-semibold tracking-[-0.035em]"
            style={{ color: colors.textPrimary, }}
          >
            Terms & Conditions
          </h1>
          <p className="text-sm" style={{ color: colors.textMuted }}>
            Last updated: December 24, 2024
          </p>
        </div>

        {/* Introduction */}
        <div 
          className="pt-5 pb-2 mb-8"
          style={{ borderTop: `1px solid ${colors.textPrimary}` }}
        >
          <p className="text-sm leading-relaxed" style={{ color: colors.textSecondary }}>
            Welcome to mind. Please read these Terms and Conditions carefully before using our service. 
            By creating an account or using the application, you acknowledge that you have read, understood, 
            and agree to be bound by these terms.
          </p>
        </div>

        {/* Sections */}
        <div className="space-y-8">
          {sections.map((section, index) => (
            <div key={index}>
              <h2 
                className="text-lg mb-3 font-semibold tracking-tight"
                style={{ color: colors.textPrimary }}
              >
                {section.title}
              </h2>
              <p 
                className="text-sm leading-relaxed"
                style={{ color: colors.textSecondary }}
              >
                {section.content}
              </p>
            </div>
          ))}
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default TermsPage;
